import React from 'react'
import { Link } from 'react-router-dom'

const NotCooperationMemberMessage: React.FC = () => (
  <div className='bg-white rounded p-4 md:w-1/2'>
    <h1 className='text-xl mb-4'>Je bent geen lid van de coöperatie Nh1816</h1>

    <p className='paragraph-light mb-4'>
      Ledenvoordelen zijn alleen beschikbaar voor leden van de coöperatie Nh1816.
      Activeer je lidmaatschap via je voorkeuren als je gebruik wilt maken van ledenvoordelen.
    </p>

    <Link
      to='/mijn-profiel/voorkeuren/lidmaatschap'
      className='primary-btn inline-flex'
    >
      Lidmaatschap bekijken
    </Link>
  </div>
)

export default NotCooperationMemberMessage
